import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../../../General/Text';
import InfoAdminBanner from '../../../../General/InfoCreditBanner/InfoCreditBanner';
import {
  AmountStyled,
  ContainerStyled,
  DatesStyled,
  PriceStyled,
} from './style/ContentStyled';
import { ReactComponent as ArrowIcon } from '../../../../../images/ui/arrow-right.svg';

import useOtherLines from '../../../../../hooks/useOtherLines';
import { Numbers } from '../../../../../helpers';

const Content = ({ effectDate, expirationDate, price }) => {
  const { isOtherLines } = useOtherLines();
  return (
    <ContainerStyled>
      {isOtherLines && <InfoAdminBanner />}
      <DatesStyled>
        <div>
          <Text
            text="Activación"
            color="#7C6D89"
            weight="400"
            size="18px"
            margin="0 0 5px 0"
          />
          <Text text={effectDate} color="#0E141D" weight="600" size="20px" />
        </div>
        <div>
          <ArrowIcon />
        </div>
        <div>
          <Text
            text="Término"
            color="#7C6D89"
            weight="400"
            size="18px"
            margin="0 0 5px 0"
          />
          <Text
            text={expirationDate}
            color="#0E141D"
            weight="600"
            size="20px"
          />
        </div>
      </DatesStyled>
      <AmountStyled>
        <Text text="Total pagar:" color="#494C66" weight="400" size="19px" />
        <PriceStyled>
          <span>$</span>
          <span>{Numbers.addThousandSeparators(Number(price))}</span>
        </PriceStyled>
      </AmountStyled>
    </ContainerStyled>
  );
};

Content.propTypes = {
  effectDate: PropTypes.string.isRequired,
  expirationDate: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

export default Content;
